import {
  greaterThanOrEqualTime,
  parseTime,
  validateTime,
  withinSchedule,
} from 'src/app/component/shared/utils';

const isDuplicateFn = a => b => Object.keys(a).every(k => a[k] === b[k]);

export interface ValidationResult {
  valid: boolean;
  message: string;
}

// temporary replace block_id with ID

export function isScheduleValid(
  schedules: any[],
  columns: string[]
): ValidationResult {
  let message = '';

  const isInvalid = schedules.some((schedule, index) => {
    const isCellInvalid = Object.values(schedule).some(
      (value: string, cellIndex) => {
        // 1. check if not empty
        if (value?.length > 0) {
        } else {
          message =
            index === 0
              ? `Found empty cell in header row`
              : `Found empty cell in row ${index}`;
          return true;
        }

        // 2. if index === 0, check header
        if (index === 0) {
          if (value !== columns[cellIndex]) {
            message = 'Invalid column value in header row';
            return true;
          }
        } else {
          // check time values
          if (cellIndex > 0) {
            // 3. check if cell is a valid time value - use duration instead?
            const isValidTime = validateTime(value);
            if (!isValidTime) {
              message = `Invalid time "${value}" at row ${index}, column ${
                cellIndex + 1
              }`;
              return true;
            }
          }
        }

        return false;
      }
    );
    if (isCellInvalid) return true;

    // check if correct column
    // if (index === 0) {
    //   console.log('Check columns: ', schedule, columns);
    // }
    if (index > 0 && index + 1 < schedules.length) {
      // 4. check for duplicate
      const slicedSchedules = schedules.slice(index + 1);
      let duplicateIndex = -1;
      const isDuplicate = slicedSchedules.some((schedule2, index2) => {
        const duplicate = isDuplicateFn(schedule2)(schedule);
        if (duplicate) {
          duplicateIndex = index2;
          return true;
        }
        return false;
      });
      if (isDuplicate) {
        message = `Duplicate entries - row ${index} & ${
          index + duplicateIndex + 1
        }`;
        return true;
      }

      // 5. check if increasing time
      // console.log('Check schedule: ', schedule);
      const scheduleArray: string[] = Object.values(schedule);
      const blockId1 = scheduleArray[0];
      const slicedTimeslots = scheduleArray.slice(1);
      const startTime1 = slicedTimeslots[0];
      const endTime1 = slicedTimeslots?.[slicedTimeslots.length - 1];
      const parsedStart1 = parseTime(startTime1);
      const parsedEnd1 = parseTime(endTime1);

      const isSchedDecreasing = slicedTimeslots.some((value, timeIndex) => {
        if (timeIndex < 1) return false;
        const time1 = parseTime(slicedTimeslots[timeIndex - 1]);
        const time2 = parseTime(value);
        if (!time1) {
          message = `Invalid time "${
            slicedTimeslots[timeIndex - 1]
          }" at row ${index}, column ${timeIndex - 1}`;
          return true;
        }
        if (!time2) {
          message = `Invalid time "${value}" at row ${index}, column ${timeIndex}`;
          return true;
        }
        const isIncreasingTime = greaterThanOrEqualTime(time2, time1);
        if (!isIncreasingTime) {
          message = `Invalid Schedule for row ${index}, column [${timeIndex}, ${
            timeIndex + 1
          }]: ${slicedTimeslots[timeIndex - 1]}-${value}`;
          return true;
        }
        return false;
      });
      if (isSchedDecreasing) return true;

      // 6. check if start / end time overlaps
      // const filteredSchedules = slicedSchedules.filter(
      //   schedule2 => schedule.id === schedule2.id
      // );
      const isOverlapSchedule = slicedSchedules.some((schedule2, index2) => {
        if (schedule.id !== schedule2.id) return false;
        const schedule2Array: string[] = Object.values(schedule2);
        const slicedTimeslots2 = schedule2Array.slice(1);
        const startTime2 = slicedTimeslots2[0];
        const endTime2 = slicedTimeslots2?.[slicedTimeslots2.length - 1];
        const parsedStart2 = parseTime(startTime2);
        const parsedEnd2 = parseTime(endTime2);

        const isTime1StartWithin2 = withinSchedule(
          parsedStart2,
          parsedEnd2,
          parsedStart1
        );
        const isTime1EndWithin2 = withinSchedule(
          parsedStart2,
          parsedEnd2,
          parsedEnd1
        );

        if (isTime1StartWithin2 || isTime1EndWithin2) {
          message = `Overlapping ${schedule.id} schedule at rows ${index} & ${
            index + index2 + 1
          }`;
          return true;
        }
        return false;
      });
      if (isOverlapSchedule) return true;
    }

    return false;
  });
  const validationResult: ValidationResult = {
    valid: isInvalid ? false : true,
    message,
  };
  return validationResult;
}
